import { CloudSearchConfig } from "../../components/shared/CloudSearchConfig";
import { OpenSearchConfig } from "../../components/shared/OpenSearchConfig";
import { OPENSEARCH_CONFIGURATION } from "../../features/equipment-list/EquipmentHelper";
import DATA_MODEL_TABLE from "../../utils/constants/dataModelTable";
import { convertToSnakeCase } from "../../utils/helpers/text";
import { entryType } from "../../constants";
import { getFieldValue } from "@digitallab/grid-common-frontend-components";

const SERIAL_NUMBER_SNAKE = convertToSnakeCase(DATA_MODEL_TABLE?.serialNumber?.key);
export const DEFAULT_SORT_BY = SERIAL_NUMBER_SNAKE + (OPENSEARCH_CONFIGURATION ? ".keyword" : "");

const checkShouldKeepFetching = (items, totalCount) => {
  return items.length < totalCount;
};

const fetchOne = async ({ variables, items }) => {
  const result = await (OPENSEARCH_CONFIGURATION ? OpenSearchConfig(variables) : CloudSearchConfig(variables));
  items = [...items, ...result?.data];
  let totalCount = result?.count;
  const shouldKeepFetching = checkShouldKeepFetching(items, totalCount);

  return { items, shouldKeepFetching, totalCount };
};

export const getAllCloudSearchData = async ({ requestObj = {} }) => {
  try {
    let items = [];
    let shouldKeepFetching = true;
    do {
      ({ items, shouldKeepFetching } = await fetchOne({
        variables: {
          negatefield: requestObj?.negatefield || "-cluster_id:*",
          sort: requestObj?.sort || "asc",
          sortBy: requestObj?.sortBy || DEFAULT_SORT_BY,
          start: items?.length,
          size: requestObj?.size || 10000,
          searchValue:
            requestObj?.searchValue ||
            `-entry_type:'${entryType?.clusterSubequipment}' AND entry_type:'${entryType?.cluster}' AND cluster_id:*`
        },
        items
      }));
    } while (shouldKeepFetching);
    return {
      items,
      error: null
    };
  } catch (err) {
    return { items: [], error: err };
  }
};

export const getMegaClusterIds = async () => {
  const requestObj = {
    negatefield: "-cluster_id:*",
    sort: "asc",
    sortBy: DEFAULT_SORT_BY,
    start: 0,
    size: 10000,
    searchValue: `-entry_type:'${entryType?.clusterSubequipment}' AND entry_type:'${entryType?.cluster}' AND cluster_id:*`
  };
  let result = await getAllCloudSearchData({ requestObj });
  let mclusterIds = [];
  if (result?.items?.length > 0) {
    mclusterIds = result?.items?.map((item) => getFieldValue(item, "cluster_id"));
  }
  return mclusterIds;
};
